function SubtractSVG() {
  return (
    <svg viewBox="0 0 176 163" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.997806 120.623C18.2002 137.896 42.0071 148.586 68.3108 148.586C120.778 148.586 163.311 106.053 163.311 53.5863C163.311 34.1235 157.458 16.0277 147.416 0.962919C164.527 18.1435 175.104 41.8366 175.104 68C175.104 120.467 132.571 163 80.1035 163C47.0992 163 18.0259 146.17 0.997806 120.623Z"
        fill="url(#paint0_linear_591_95154)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_591_95154"
          x1="74.2066"
          y1="163"
          x2="175.074"
          y2="79.1192"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F47521" />
          <stop offset="1" stopColor="#FAB818" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export { SubtractSVG };
